import {
  CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_BEGIN,
  CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_SUCCESS,
  CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_FAILURE,
  CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_DISMISS_ERROR,
} from './constants'

import { getAllCategories } from 'BFF/BFF_datamasters/getCategories'


export function loadSchemaCategories() {
  return (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      getAllCategories().then(categories => {
        dispatch({
          type: CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_SUCCESS,
          data: { categories },
        })
        return resolve({ categories })
      }).catch(error => {
        console.error(error)
        dispatch({
          type: CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_FAILURE,
          data: { error },
        })
        reject(error)
      })

    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadSchemasFromMaestroError() {
  return {
    type: CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_BEGIN:
      return {
        ...state,
        loadSchemaCategoriesPending: true,
        loadSchemaCategoriesError: null,
        categories: [],
      }

    case CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_SUCCESS: {
      // The request is success
      const { categories } = action.data
      return {
        ...state,
        loadSchemaCategoriesPending: false,
        loadSchemaCategoriesError: null,
        categories,
      }
    }

    case CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_FAILURE: {
      const { error } = action.data
      return {
        ...state,
        loadSchemaCategoriesPending: false,
        loadSchemaCategoriesError: error,
        categories: [],
      }
    }

    case CAR_DATA_MASTER_LOAD_SCHEMA_CATEGORIES_DISMISS_ERROR:
      return {
        ...state,
        loadSchemasFromMaestroError: null,
      }

    default:
      return state
  }
}
